<mat-nav-list class="main-nav-list">
  <div class="main-nav-list__top">
    <a mat-list-item class="toggle-menu" (click)="toggleSidenavPinned()">
      @if (!sidenavPinned()) {
        <mat-icon class="menuTrigger menuTrigger--default" svgIcon="menu" />
      } @else {
        <mat-icon
          class="menuTrigger menuTrigger--collapse"
          svgIcon="chevron-double-left"
          matTooltip="Collapse"
        />
      }

      <span class="toggle-menu__text">Navigation</span>
    </a>

    @for (item of menuItems; track item.link) {
      <a mat-list-item routerLinkActive="active" [routerLink]="[item.link]">
        <mat-icon
          matTooltipPosition="right"
          [svgIcon]="item.icon"
          [matTooltip]="item.label"
          [matTooltipDisabled]="sidenavPinned()"
        />
        <span class="toggle-menu__text">{{ item.label }}</span>
      </a>
    }
  </div>

  @if (canShowSupport()) {
    <a
      mat-list-item
      appZendeskSupportToggle
      class="support-toggle"
      data-cy="support-sidenav-button"
      [ngClass]="{ 'active': isSupportOpen() }"
    >
      <mat-icon
        class="sidebar-support"
        matTooltipPosition="right"
        svgIcon="message-text"
        matTooltip="Support"
        matBadgeSize="small"
        [matTooltipDisabled]="sidenavPinned()"
        [matBadge]="supportUnreadCount()"
        [matBadgeHidden]="!supportUnreadCount()"
      />
      <span class="toggle-menu__text">Support</span>
    </a>
  }
</mat-nav-list>
